import { useMemo } from 'react'

import { TextField, type TextFieldProps } from '@mui/material'

import { zPhoneNumber } from '@/lib/zod'

type Props = Pick<
  TextFieldProps,
  | 'name'
  | 'value'
  | 'disabled'
  | 'label'
  | 'placeholder'
  | 'required'
  | 'error'
  | 'helperText'
  | 'fullWidth'
  | 'autoFocus'
  | 'onChange'
  | 'onBlur'
  | 'onKeyDown'
  | 'sx'
>

export function PhoneField({ ref, ...props }: PropsWithRef<Props, HTMLInputElement>) {
  const value = useMemo(() => {
    const result = zPhoneNumber().safeParse(props.value)
    return result.success ? result.data : props.value
  }, [props.value])

  return <TextField {...props} inputRef={ref} value={value} inputProps={{ maxLength: 14 }} />
}
